import apolloClient from '@/store/apollo';

// import ProductGql from '@/store/graphql/queries/Product.gql'
import CmsGql from '@/store/graphql/queries/Cms.gql';

export default {
    fetchCms: base_url =>
        new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: CmsGql,
                    variables: {
                        base_url
                    }
                })
                .then(({ data }) => resolve(data.CP_Cms))
                .catch(error => reject(error.message));
        })
};
